const frontendVersion = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';

interface VersionDisplay {
  text: string;
  tooltip: string;
}

export function getVersionDisplay(
  backendVersion: string | undefined,
  isError: boolean,
  isLoading: boolean,
): VersionDisplay {
  if (isLoading) {
    return {
      text: `v${frontendVersion}`,
      tooltip: `Frontend ${frontendVersion}, backend loading...`,
    };
  }

  if (isError) {
    return {
      text: `FE ${frontendVersion} / BE down`,
      tooltip: `Frontend ${frontendVersion}, backend is unreachable`,
    };
  }

  if (!backendVersion) {
    return {
      text: `FE ${frontendVersion} / BE unknown`,
      tooltip: `Frontend ${frontendVersion}, backend version unknown`,
    };
  }

  if (frontendVersion === backendVersion) {
    return {
      text: `v${frontendVersion}`,
      tooltip: `Frontend and backend both at ${frontendVersion}`,
    };
  }

  return {
    text: `FE ${frontendVersion} / BE ${backendVersion}`,
    tooltip: `Frontend ${frontendVersion}, Backend ${backendVersion}`,
  };
}
